<template>
  <v-text-field ref="amount" v-model="amount" @blur="$emit('blur')" :hint="hint" persistent-hint :label="label" :outlined="outlined" :error-messages="errorMessages" :rules="rules" :required="required" :readonly="readonly" :disabled="disabled" style="direction: ltr; text-align: left" />
</template>

<script>
  import { mask, unmask } from '@/util/helpers'
  export default {
    name: 'InputMoney',
    props: {
      options: {
        type: Object,
        default: () => { return {} },
      },
      label: { type: String },
      errorMessages: { type: String },
      hint: { type: String },
      rules: { type: Array },
      value: [String, Number],
      required: { type: Boolean, default: true },
      readonly: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
      outlined: { type: Boolean, default: false },
    },
    data: () => {
      return {
        amount_: 0,
      }
    },
    computed: {
      amount: {
        get() {
          return mask(this.amount_, 0)
        },
        set(value) {
          this.amount_ = unmask(value)
          this.$emit('input', Number(this.amount_))
          this.$emit('change', Number(this.amount_))
        },
      },
    },
    mounted() {
      if (this.value)
        this.amount = this.value
    },
    watch: {
      value: {
        handler(val, oldVal) {
          this.amount = val
        },
      },
    },
  }
</script>
